const updates = [
  {
    date: '2026-07-29',
    title: '「她的私密恋爱」第128话更新',
    desc: '本季最热恋爱韩漫最新话上线，剧情迎来关键转折，男女主角关系出现微妙变化。',
    badge: '热门更新',
  },
  {
    date: '2026-07-28',
    title: '五部新番韩漫今日上架',
    desc: '涵盖奇幻、校园、都市三种题材，五部全新韩漫作品正式加入韩漫屋书库。',
    badge: '新番上架',
  },
  {
    date: '2026-07-27',
    title: '「暗夜行者」第二季确认制作',
    desc: '高人气悬疑韩漫宣布续订，第二季剧情将深入揭开主角身世之谜，预计秋季上线。',
    badge: '重磅消息',
  },
  {
    date: '2026-07-26',
    title: '平台阅读体验全面升级',
    desc: '优化了下拉式阅读的流畅度与图片加载速度，新增夜间模式与书签功能。',
    badge: '功能更新',
  },
  {
    date: '2026-07-25',
    title: '「异界剑圣传」单周阅读量破百万',
    desc: '奇幻韩漫标杆之作再创纪录，成为韩漫屋本周阅读量最高的作品。',
    badge: '数据里程碑',
  },
  {
    date: '2026-07-24',
    title: '古风韩漫专区全新改版',
    desc: '重新整理了古风题材分类，新增朝代背景筛选功能，方便精准找漫。',
    badge: '专区优化',
  },
  {
    date: '2026-07-23',
    title: '韩漫屋读者社群突破50万人',
    desc: '感谢每一位读者的支持，韩漫屋将继续坚持全章节免费阅读的初心。',
    badge: '社区喜报',
  },
];

const badgeColors: Record<string, string> = {
  '热门更新': 'bg-accent-100 text-accent-700',
  '新番上架': 'bg-primary-100 text-primary-700',
  '重磅消息': 'bg-accent-100 text-accent-700',
  '功能更新': 'bg-secondary-100 text-secondary-700',
  '数据里程碑': 'bg-primary-100 text-primary-700',
  '专区优化': 'bg-secondary-100 text-secondary-700',
  '社区喜报': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            韩漫屋最新动态与韩漫资讯，第一时间掌握平台更新与漫画圈热点
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200 space-y-8 md:space-y-10">
            {updates.map((item, idx) => (
              <div key={idx} className="relative">
                <span className="absolute -left-[41px] md:-left-[45px] top-1 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-100"></span>
                <div>
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-1.5">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${badgeColors[item.badge]}`}>
                      {item.badge}
                    </span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}